import { getSessionFeedbackEvent } from '@/components/feedbacks/feedback-issues';
import { normalizeNewlines } from '@/lib/string-utils';
import {
  countSessionsAttendedForSchoolReport,
  CsvCellValue,
  formatDateRange,
  formatInstant,
  FrequentTimeZones,
} from '@airreading/common';
import {
  SchoolReport,
  SchoolReportsTableColumnId,
  formatStudentTagList,
  sessionAttendanceOption,
  studentYearOptionOnlyNumber,
} from '@airreading/common/data';

export const getSchoolReportsTableOverrides = (): Partial<
  Record<SchoolReportsTableColumnId, (row: SchoolReport, index: number) => CsvCellValue>
> => {
  const timeZone = FrequentTimeZones.UsCentral;

  return {
    dateRange: (row) => formatDateRange(row.startedAtInstant, row.endedAtInstant, timeZone),
    school: (row) => row.school?.name ?? '-',
    district: (row) => row.school?.org.name ?? '-',
    studentTags: (row) => formatStudentTagList(row.student.studentTags),
    classroomTeacher: (row) => row.student.classroomTeacher ?? '-',
    report: (row) => normalizeNewlines(row.report),
    grade: (row) => studentYearOptionOnlyNumber(row.grade),
    student: (row) => row.student.fullNameOrEmail ?? null,
    studentFirstName: (row) => row.student.firstName ?? '-',
    studentLastName: (row) => row.student.lastName ?? '-',
    reportFromAI: (row) => row.reportFromAI ?? '-',
    reportFromAISpanish: (row) => row.reportFromAISpanish ?? '-',
    floridaStandards: (row) => row.floridaStandards || '-',
    arkansasStandards: (row) => row.arkansasStandards || '-',
    studentFeedbackEvents: (row) =>
      row.sessions
        .flatMap((session) => {
          const { formattedDate } = formatInstant(session.startInstant, FrequentTimeZones.UsCentral);
          const feedback = session.sessionFeedbacks?.find((feedback) => feedback.studentId === row.studentId);
          const event = getSessionFeedbackEvent({
            studentAttended: !!feedback?.studentAttended,
            issues: feedback?.issues ?? [],
          });
          return event ? [`${event.toLowerCase()} [${formattedDate}]`] : [];
        })
        .join(', '),
    sessionAttendance: (row) =>
      sessionAttendanceOption(row, timeZone, `${window.location.origin}/sessions/session-feedbacks`),
    numberOfSessionsAttended: (row) => countSessionsAttendedForSchoolReport(row),
  };
};
